import { render, staticRenderFns } from "./InformacoesPreparoInox.vue?vue&type=template&id=7796b00f&"
import script from "./InformacoesPreparoInox.vue?vue&type=script&lang=js&"
export * from "./InformacoesPreparoInox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports